import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-fontawesome',
	templateUrl:'./FontAwesomePluginPage.html',
	styles: [],
	styleUrls:['./FontAwesomePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomePluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_570 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>font-awesome</artifactId>
</dependency>
\`\`\``;
	mdContent_571 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:font-awesome:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_572 = `\`\`\`json
"@fortawesome/angular-fontawesome": "^4.0.0"
"@fortawesome/free-solid-svg-icons": "^7.2.0"
"@fortawesome/fontawesome-svg-core": "^7.2.0"
"@fortawesome/free-brands-svg-icons": "^6.2.2"
\`\`\``;
	mdContent_573 = `\`\`\`java
// Solid icon
FontAwesome icon = new FontAwesome(
    FontAwesomeStyles.Solid,
    FontAwesomeIcons.cog);

// Brand icon
FontAwesome github = IFontAwesome.createIcon(
    FontAwesomeBrandIcons.github,
    FontAwesomeStyles.Brand);

// With animation
icon.spin().setSize(FontAwesomeSizes.Fa3x);
\`\`\``;
	mdContent_574 = `\`\`\`java
var layers = new FontAwesomeLayers<>();
layers.add(new FontAwesome(FontAwesomeStyles.Solid, FontAwesomeIcons.envelope));
layers.add(new FontAwesomeLayerCounter("99+"));
\`\`\``;
	mdContent_575 = `\`\`\`java
// Solid icon
FontAwesome icon = new FontAwesome(
    FontAwesomeStyles.Solid,
    FontAwesomeIcons.cog);

// Brand icon
FontAwesome github = IFontAwesome.createIcon(
    FontAwesomeBrandIcons.github,
    FontAwesomeStyles.Brand);

// With animation
icon.spin().setSize(FontAwesomeSizes.Fa3x);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
